import { createSlice } from "@reduxjs/toolkit";

//CONSTANTS
export const MARKUP_COLOUR = "markupColour";
export const MARKUP_FONT_SIZE = "markupFontSize";
export const MARKUP_LINE_SIZE = "markupLineSize";
export const PROJECT_MARKUP_DATA = "projectMarkupData";
export const FILTERED_MARKUPS = "filteredMarkups";
export const ARCHIVED_MARKUPS = "archivedMarkups";
export const CREATED_BY_LIST = "createdByList";
export const CREATED_FOR_LIST = "createdForList";
export const MARKUPS_LOADING = "markupsLoading";

//INITIAL STATE OBJECT
const initialState = {
  [MARKUP_COLOUR]: "#ff0000",
  [MARKUP_FONT_SIZE]: "2",
  [MARKUP_LINE_SIZE]: "3",
  [PROJECT_MARKUP_DATA]: null,
  [FILTERED_MARKUPS]: null,
  [ARCHIVED_MARKUPS]: null,
  [CREATED_BY_LIST]: "",
  [CREATED_FOR_LIST]: "",
  [MARKUPS_LOADING]: false,
};

export const markupSlice = createSlice({
  name: "markupReducer",
  initialState: initialState,
  reducers: {
    updateMarkupState: (state, action) => {
      // state[action.payload.stateName] = action.payload.value;

      return {
        ...state,
        [action.payload.stateName]: action.payload.value,
      };
    },
  },
});

export const { updateMarkupState } = markupSlice.actions;

export const markupReducer = markupSlice.reducer;
